import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";

var numberOfPagesFromItems = function numberOfPagesFromItems(items, itemsPerPage) {
  return Math.ceil(items / itemsPerPage);
};

var getPagesRange = function getPagesRange(from, to) {
  return Array.from(Array(to + 1 - from).keys()).map(function (i) {
    return from + i;
  });
};

var changePageIfAppropriate = function changePageIfAppropriate(nextPage, totalItems, itemsPerPage, onPageChanged) {
  var pageCount = numberOfPagesFromItems(totalItems, itemsPerPage);
  var nextPageExists = nextPage > 0 && nextPage <= pageCount;

  if (nextPageExists && typeof onPageChanged === "function") {
    onPageChanged(nextPage);
  }
};

export { changePageIfAppropriate, getPagesRange, numberOfPagesFromItems };